// extracted by mini-css-extract-plugin
export default {"svgLogo":"socialLinks_svgLogo__2m40G"};